require('owlcarousel/owl-carousel/owl.carousel.js');
require('owlcarousel/owl-carousel/owl.carousel.css');
require('owlcarousel/owl-carousel/owl.transitions.css');

function initProduct() {

	if( $('.product_intro').length ){

		$.fn.extend({
		    animateCss: function (animationName) {
		        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
		        this.addClass('animated ' + animationName).one(animationEnd, function() {
		            $(this).removeClass('animated ' + animationName);
		        });
		    }
		});

		var intro_effects = ['ProductIntroslideInUp', 'ProductIntroslideInRight', 'ProductIntroslideInLeft'];
		var intro_slider = $('#product_intro_slider');
		intro_slider.owlCarousel({
			autoPlay : 5000,
			rewindNav : false,
		    navigation : false,
		    pagination : false,
		    singleItem : true,
		    transitionStyle : "fade",
		    addClassActive: true,
		    mouseDrag : false,
		    touchDrag: false,
		    lazyLoad: false,
		    autoHeight: false,
		    afterInit: function() {
		    	$('.owl-item img').addClass('lazypreload');
		    },
		    afterAction: function( slider ){

		    	var index = $('.owl-item.active').index() % 3;
		    	//$('.owl-item img').finish();
		    	$('.owl-item.active img').animateCss( intro_effects[index] );

		    }
		});

	}

	// Disable tab link and open gallery
	// $('#product_curves_link').off('click').on('click', function(e){
	// 	e.preventDefault();
	// 	$('#product_curves a:first').click();
	// });

	$('.product-tab-widget .tab_title a').on('click', function(e){

		e.preventDefault();

		var target = $(this).attr('href');

		$('.product-tab-widget .tab_title a').removeClass('active');
		$(this).addClass('active');

		$('.product_tab_content').removeClass('active');
		$(target).addClass('active');

		//$('html, body').animate({scrollTop: $(target).offset().top}, 'slow');
		$('html, body').animate({scrollTop: $('.product_tab_contents').offset().top}, 'slow');

	});

    document.addEventListener('lazybeforesizes', function(e) {
        checkFlickrPortrait(e.target);
    }, false);

    $('#buy_block').on('submit', function(e){
    	if( !$('#idCombination').val() ){
    		return false;
    	}

    	return true;
    });

    $('#buy_block .add_to_cart').on('click', function(e){
    	var id_combination = $(this).find('input').val();
    	$('#idCombination').val(id_combination);
    	return true;
    });
}

module.exports = initProduct;




// WEBPACK FOOTER //
// ./js/product.js